module.exports = __webpack_public_path__ + "static/img/6004_phase_function_Paper_PointsHejduk_Prediction.a509fc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6004_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Nvn0
// module chunks = 0